import React from 'react';
import { Loan } from '../types/loan';
import { FileSpreadsheetIcon, TrendingUpIcon, DollarSignIcon, TargetIcon } from 'lucide-react';
interface SummaryCardsProps {
  loans: Loan[];
  currentMarketRate: number;
}
export function SummaryCards({
  loans,
  currentMarketRate
}: SummaryCardsProps) {
  const totalLoans = loans.length;
  const totalVolume = loans.reduce((sum, loan) => sum + loan.loanAmount, 0);
  const rateDifferences = loans.map(loan => loan.interestRate - currentMarketRate);
  const averageRateDiff = totalLoans > 0 ? rateDifferences.reduce((sum, diff) => sum + diff, 0) / totalLoans : 0;
  const highestRateDiff = totalLoans > 0 ? Math.max(...rateDifferences) : 0;
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(value);
  };
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-258">
      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-200" data-id="element-259">
        <div className="p-3.5 bg-violet-50 text-violet-600 rounded-xl" data-id="element-260">
          <TargetIcon className="w-6 h-6" data-id="element-261" />
        </div>
        <div data-id="element-262">
          <p className="text-sm font-medium text-gray-500" data-id="element-263">Matching Loans</p>
          <p className="text-2xl font-bold text-gray-900 tabular-nums" data-id="element-264">
            {totalLoans}
          </p>
        </div>
      </div>

      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-200" data-id="element-265">
        <div className="p-3.5 bg-green-50 text-green-600 rounded-xl" data-id="element-266">
          <DollarSignIcon className="w-6 h-6" data-id="element-267" />
        </div>
        <div data-id="element-268">
          <p className="text-sm font-medium text-gray-500" data-id="element-269">Total Volume</p>
          <p className="text-2xl font-bold text-gray-900 tabular-nums" data-id="element-270">
            {formatCurrency(totalVolume)}
          </p>
        </div>
      </div>

      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-200" data-id="element-271">
        <div className="p-3.5 bg-cyan-50 text-cyan-600 rounded-xl" data-id="element-272">
          <TrendingUpIcon className="w-6 h-6" data-id="element-273" />
        </div>
        <div data-id="element-274">
          <p className="text-sm font-medium text-gray-500" data-id="element-275">Avg Rate Diff</p>
          <p className="text-2xl font-bold text-gray-900 tabular-nums" data-id="element-276">
            +{averageRateDiff.toFixed(2)}%
          </p>
        </div>
      </div>

      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4 hover:shadow-md hover:border-gray-200 transition-all duration-200" data-id="element-277">
        <div className="p-3.5 bg-red-50 text-red-600 rounded-xl" data-id="element-278">
          <FileSpreadsheetIcon className="w-6 h-6" data-id="element-279" />
        </div>
        <div data-id="element-280">
          <p className="text-sm font-medium text-gray-500" data-id="element-281">Highest Rate Diff</p>
          <p className="text-2xl font-bold text-gray-900 tabular-nums" data-id="element-282">
            +{highestRateDiff.toFixed(2)}%
          </p>
        </div>
      </div>
    </div>;
}